import { render } from "./oti_config.vue?vue&type=template&id=91ea4bda&scoped=true"
import script from "./oti_config.vue?vue&type=script&lang=js"
export * from "./oti_config.vue?vue&type=script&lang=js"

import "./oti_config.vue?vue&type=style&index=0&id=91ea4bda&scoped=true&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ea4bda"]])

export default __exports__